export default "__VITE_ASSET__Bi15APEB__";